function isSpeechSythesisAvailable() {

    if (window.speechSynthesis && window.SpeechSynthesisEvent && window.SpeechSynthesisUtterance) {
        return true;
    }

    return false;
}

function getVoice( filterFn ) {

    try {
        return speechSynthesis.getVoices().filter( filterFn )[ 0 ];
    } catch (e) {}

    return null;
}

function getDefaultVoice() {
    return getVoice( v => v.default );
}


export class SimpleSpeechSynthesis {

    text = ''

    utterance = null;

    onstart;

    constructor( text ) {
        if (!isSpeechSythesisAvailable()) throw "SpeechSynthesis API not available";

        if (text) this.setText( text );
    }

    speak() {
        if (this.utterance == null) return;

        window.speechSynthesis.speak( this.utterance );
    }

    cancel() {
        window.speechSynthesis.cancel();
    }

    get speaking() {
        return window.speechSynthesis.speaking;
    }

    toggle() {
        if (this.speaking) {
            this.cancel();
        } else {
            this.speak();
        }
    }

    setText( text ) {

        text = SimpleSpeechSynthesis.parseText( text );

        this.text = text;

        this.utterance = new SpeechSynthesisUtterance( this.text );

        this.utterance.voice = getDefaultVoice();

        this.utterance.addEventListener( "start", (event) => {
            if (typeof this.onstart == 'function') {
                this.onstart( event );
            }
        });
    }

    static parseText( text ) {

        if (typeof text != 'string') return '';

        text = text.trim();

        if (text.length == 0) return '';

        return text;
    }

    static FromText( text ) {

        try {

            if (!isSpeechSythesisAvailable()) return null;

            if (text) {
                text = SimpleSpeechSynthesis.parseText( text );

                if (text) {
                    return new SimpleSpeechSynthesis( text );
                }
            }
        } catch (e) {}

        return null;
    }

    static FromHtml( html ) {

        try {

            if (!isSpeechSythesisAvailable()) return null;

            if (html) {
    
                html = html.replace( "<br>", "\n" )
    
                let text = $(`<div>`).html( html ).text();

                return SimpleSpeechSynthesis.FromText( text );
            }

        } catch (e) {}

        return null;
    }
}